import { render } from "./Minus.vue?vue&type=template&id=1bc26aa4"
import script from "./Minus.vue?vue&type=script&lang=js"
export * from "./Minus.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Minus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bc26aa4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bc26aa4', __exports__)) {
    api.reload('1bc26aa4', __exports__)
  }
  
  module.hot.accept("./Minus.vue?vue&type=template&id=1bc26aa4", () => {
    api.rerender('1bc26aa4', render)
  })

}


export default __exports__